import Dashboard from 'src/wrapper/dashboard/teacher';
import Account from 'src/wrapper/account';
import StudentList from 'src/wrapper/teachers/student-list';
import AssetFolders from 'src/wrapper/assets/folders';
import AssetFiles from 'src/wrapper/assets/files';
import PayslipList from 'src/wrapper/teachers/payslip-list';
import FuelList from 'src/wrapper/teachers/fuel-list';
import FuelDetail from 'src/wrapper/teachers/fuel-detail';
import RepairList from 'src/wrapper/teachers/repair-list';
import RepairDetail from 'src/wrapper/teachers/repair-detail';
import TmsList from 'src/wrapper/teachers/tms-list';
import TmsDetail from 'src/wrapper/teachers/tms-detail';
import TmsRedirect from 'src/wrapper/teachers/tms-redirect';
import workSchedule from 'src/wrapper/teachers/work-schedule';
import RepairRequests from 'src/wrapper/teachers/repair-requests';
import Information from 'src/wrapper/teachers/teacher-infor';
import OrderDetail from 'src/wrapper/teachers/order-detail';
import OrderList from 'src/wrapper/teachers/order-list';
import SessionDetail from 'src/wrapper/teachers/session-detail';

export const teacherRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.account, component: Account },
    { path: paths.dashboard.information, component: Information },
    { path: paths.students.index, component: StudentList },
    { path: paths.assets.index, component: AssetFolders },
    { path: paths.assets.files, component: AssetFiles },
    { path: paths.payslips.index, component: PayslipList },
    { path: paths.fuels.index, component: FuelList },
    { path: paths.fuels.details, component: FuelDetail },
    { path: paths.repairs.index, component: RepairList },
    { path: paths.repairs.details, component: RepairDetail },
    { path: paths.repairs.requests, component: RepairRequests },
    { path: paths.tms.index, component: TmsList },
    { path: paths.tms.details, component: TmsDetail },
    { path: paths.tms.redirect, component: TmsRedirect },
    { path: paths.schedules.work.index, component: workSchedule },
    { path: paths.orders.index, component: OrderList },
    { path: paths.orders.details, component: OrderDetail },
    { path: paths.sessions.details, component: SessionDetail },
  ];
};
